import { useCallback, useState } from "react";

import { useAuthContext } from "../../../Components/AuthContext";
import { Alert } from "../../../Components/ui";
import { AlimTalkAccountMode } from "../../../api/services/notification-center.service";
import AlimTalkChannelSettings from "./AlimTalkChannelSettings";
import AlimTalkTemplateManagement from "./AlimTalkTemplateManagement";
import HeadquartersAlimTalkSenderSettings from "./HeadquartersAlimTalkSenderSettings";
import SystemMessageSettings from "./SystemMessageSettings";

export default function HqAdminSettings() {
  const { userInfo } = useAuthContext();
  const [accountMode, setAccountMode] = useState<AlimTalkAccountMode | null>(null);
  const [accountModeResolved, setAccountModeResolved] = useState(false);

  const handleAccountModeChange = useCallback((nextMode: AlimTalkAccountMode | null) => {
    setAccountMode(nextMode);
    setAccountModeResolved(true);
  }, []);

  if (userInfo?.is_hq_admin !== true) {
    return <Alert color="warning">HQ 관리자만 본사 알림톡 설정을 관리할 수 있습니다.</Alert>;
  }

  return (
    <div className="d-flex flex-column gap-4">
      <section aria-labelledby="hq-sender-settings-title">
        <h4 id="hq-sender-settings-title" className="mb-3">본사 발신번호 관리</h4>
        <HeadquartersAlimTalkSenderSettings />
      </section>

      <section className="border-top pt-4" aria-labelledby="hq-channel-settings-title">
        <h4 id="hq-channel-settings-title" className="mb-3">계정·충전금 관리</h4>
        <AlimTalkChannelSettings
          view="headquarters"
          onAccountModeChange={handleAccountModeChange}
        />
      </section>

      {accountModeResolved && accountMode === "DIRECT" ? (
        <Alert color="info">현재 지점은 직접 계정을 사용 중입니다. 본사 공용 계정으로 전환하면 HQ 템플릿과 시스템 메시지 설정을 관리할 수 있습니다.</Alert>
      ) : null}

      {accountMode === "HEADQUARTERS" ? (
        <>
          <section className="border-top pt-4" aria-labelledby="hq-template-settings-title">
            <h4 id="hq-template-settings-title" className="mb-3">본사 템플릿 관리</h4>
            <AlimTalkTemplateManagement view="headquarters" accountModeOverride={accountMode} />
          </section>

          <section className="border-top pt-4" aria-labelledby="hq-system-settings-title">
            <h4 id="hq-system-settings-title" className="mb-3">본사 시스템 메시지 관리</h4>
            <SystemMessageSettings view="headquarters" accountModeOverride={accountMode} />
          </section>
        </>
      ) : null}
    </div>
  );
}
